import { PayloadAction } from '@reduxjs/toolkit';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { ContentReducerCreator } from '../types';

const setProjectsFilterReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<TReactSelectOption[]>) => {
    state.projectsFilter = action.payload;
  });
};

export default setProjectsFilterReducer;
